import React from 'react';
import clsx from 'clsx';
import { makeStyles, TextField, Typography } from '@material-ui/core';

import Style from './Style';

const useStyles = makeStyles(() => Style());

export default function VehicleFields({
  handleChangeLicensePlate,
  handleChangeMcNumber,
  handleChangeUnitNumber,
  vehicleData = '',
  usedIn,
}) {
  const classes = useStyles();

  const {
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    displacement = null,
    licensePlate = '',
    vin = '',
    mcNumber = '',
    unitNumber = '',
  } = vehicleData;
  return (
    <div className={clsx(classes.fields__main, 'w-100')}>
      <div className='d-flex space-between'>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>Vehicle Make</Typography>
          <TextField
            disabled
            value={vehicleMake}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>Vehicle Model</Typography>
          <TextField
            disabled
            value={vehicleModel}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
      </div>
      <div className='d-flex space-between'>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>Model Year</Typography>
          <TextField
            disabled
            value={modelYear}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>Engine Size</Typography>
          <TextField
            disabled
            value={displacement}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
      </div>
      <div className='d-flex space-between'>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>
            License Plate{usedIn === 'vin' && '*'}
          </Typography>
          <TextField
            disabled={usedIn !== 'vin'}
            type='text'
            name='licensePlate'
            placeholder={usedIn === 'vin' ? 'Enter License Plate' : ''}
            onChange={
              usedIn === 'vin'
                ? (e) => {
                    const value = e.target.value?.toString() || '';

                    if (/^[a-zA-Z0-9]*$/.test(value) && value.length < 16) {
                      handleChangeLicensePlate(value);
                    }
                  }
                : () => {}
            }
            value={licensePlate || ''}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>VIN</Typography>
          <TextField
            disabled
            value={vin}
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
      </div>
      <div className='d-flex space-between'>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>Unit Number</Typography>
          <TextField
            type='text'
            name='unitNumber'
            placeholder='Enter Unit Number'
            onChange={handleChangeUnitNumber}
            value={unitNumber || ''}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
          />
        </div>
        <div className={classes.flex__field}>
          <Typography className={classes.label}>MC Number</Typography>
          <TextField
            value={mcNumber}
            placeholder='Enter MC Number'
            InputProps={{
              disableUnderline: true,
            }}
            className={clsx(classes.data__field, 'c-pointer')}
            onChange={handleChangeMcNumber}
          />
        </div>
      </div>
    </div>
  );
}
